import { render, staticRenderFns } from "./FacultyCoeEvaluateStudents.vue?vue&type=template&id=901e8bcc&scoped=true"
import script from "./FacultyCoeEvaluateStudents.vue?vue&type=script&lang=js"
export * from "./FacultyCoeEvaluateStudents.vue?vue&type=script&lang=js"
import style0 from "./FacultyCoeEvaluateStudents.vue?vue&type=style&index=0&id=901e8bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e8bcc",
  null
  
)

export default component.exports